import BaseStore from "@/v1/utils/BaseStore";

/**x
 * Initial State
 */

const initialState = baseState => ({
  ...baseState,
  filters: [
    {
      key: "type",
      title: "label.type",
      icon: "type",
      active: false,
      values: [],
      metadata: [],
    },
    {
      key: "source",
      title: "label.source",
      icon: "type",
      active: false,
      values: [],
      metadata: [],
    },
  ],
});

const store = new BaseStore("currencies", initialState);

export default store.reducer();
